import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd } from '@angular/router';
import { Router } from '@angular/router';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { Title } from '@angular/platform-browser';
import { filter, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { version } from '../../package.json';
import { CloudNotificationService } from './services/cloud-notification.service';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Observable, Subject } from 'rxjs';
import { LocalStorageService } from './services/localstorage.service';
import { CloudAuthenticationService } from './services/cloud-authentication.service';
import { DefaultExpirationValues } from './Util/constants';
import Helper from './Util/helper';
import { HttpErrorResponse } from '@angular/common/http';
import { CloudNotificationStyle } from './models/cloud-notification-style.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})

export class AppComponent implements OnInit,OnDestroy {

  faBars = faBars;
  routerUrl: Router;
  private unsubscribe$ = new Subject<void>();

  public version: string = version;

  constructor(
    private readonly authSvc: CloudAuthenticationService,
    private readonly localStorage: LocalStorageService,
    private readonly idle: Idle,
    private readonly notificationSvc: CloudNotificationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleSvc: Title) {
    this.routerUrl = router;
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next(null)
    this.unsubscribe$.complete()
  }




  ngOnInit() {

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd), distinctUntilChanged()).subscribe(() => {
      this.titleSvc.setTitle(this.setTitle(this.activatedRoute.root, environment.default_browser_title) + environment.default_browser_title_suffix);
    })

    this.authSvc.loginEvent.subscribe(() => {
      this.initializeIdleTracking();
    });

    this.initializeIdleTracking();
  }

  initializeIdleTracking(): void {

      this.authSvc.getUserIdleTime().pipe(takeUntil(this.unsubscribe$)).subscribe({

        next: (time) => {
          const idleTime = time || DefaultExpirationValues.USER_INACTIVITY_EXPIRY_TIME_SEC;
          this.setIdleTracking(idleTime);
        },

        error: (err: HttpErrorResponse) => {
          console.error(Helper.resolveErrorMessage(err))
          this.setIdleTracking(DefaultExpirationValues.USER_INACTIVITY_EXPIRY_TIME_SEC);
        }

      });

  }

  private setIdleTracking(idleTime: number): void {

    this.idle.setIdle(idleTime);

    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onIdleStart.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.notificationSvc.createToastNotification("App Component","Your session expired due to inactivity. Please log in again to continue.",CloudNotificationStyle.danger)
      this.authSvc.logout(true, false)
    });

    this.idle.watch();
  }

  setTitle(route: ActivatedRoute, title: string): string {
    if (route.routeConfig && route.routeConfig.data && route.routeConfig.data.browserTitle) {
      title = route.routeConfig.data.browserTitle;
    }
    if (route.firstChild) {
      // If we are not on our current path yet,
      // there will be more children to look after, to build our breadcumb
      return this.setTitle(route.firstChild, title);
    }
    return title;
  }


}
